"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showConfirm = exports.showAlert = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable sonarjs/cognitive-complexity */
var react_1 = require("react");
var usePromiseCallback_1 = tslib_1.__importDefault(require("@eduzz/houston-hooks/usePromiseCallback"));
var Button_1 = tslib_1.__importDefault(require("../Button"));
var Dialog_1 = tslib_1.__importDefault(require("./Dialog"));
var lastPromise = Promise.resolve(false);
var componentCallback;
var DialogGlobal = (0, react_1.memo)(function () {
    var _a;
    var _b = tslib_1.__read((0, react_1.useState)(false), 2), opened = _b[0], setOpened = _b[1];
    var _c = tslib_1.__read((0, react_1.useState)(), 2), params = _c[0], setParams = _c[1];
    var _d = tslib_1.__read((0, react_1.useState)(false), 2), confirmLoading = _d[0], setConfirmLoading = _d[1];
    var _e = tslib_1.__read((0, react_1.useState)(false), 2), cancelLoading = _e[0], setCancelLoading = _e[1];
    var onReceiveParams = (0, usePromiseCallback_1.default)(function (isSubscribed, params) {
        var result = new Promise(function (resolve, reject) {
            setOpened(true);
            setConfirmLoading(false);
            setCancelLoading(false);
            setParams(tslib_1.__assign(tslib_1.__assign({ confirmation: false, title: undefined }, params), { onConfirm: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                    var err_1;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!params.onConfirm) {
                                    resolve(true);
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, 4, 5]);
                                isSubscribed() && setConfirmLoading(true);
                                return [4 /*yield*/, Promise.resolve(params.onConfirm())];
                            case 2:
                                _a.sent();
                                resolve(true);
                                return [3 /*break*/, 5];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [3 /*break*/, 5];
                            case 4:
                                isSubscribed() && setConfirmLoading(false);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); }, onCancel: function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                    var err_2;
                    return tslib_1.__generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!params.onCancel) {
                                    resolve(true);
                                    return [2 /*return*/];
                                }
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, 4, 5]);
                                isSubscribed() && setCancelLoading(true);
                                return [4 /*yield*/, Promise.resolve(params.onCancel())];
                            case 2:
                                _a.sent();
                                resolve(false);
                                return [3 /*break*/, 5];
                            case 3:
                                err_2 = _a.sent();
                                reject(err_2);
                                return [3 /*break*/, 5];
                            case 4:
                                isSubscribed() && setCancelLoading(false);
                                return [7 /*endfinally*/];
                            case 5: return [2 /*return*/];
                        }
                    });
                }); } }));
        });
        result.finally(function () { return setOpened(false); });
        return result;
    }, []);
    (0, react_1.useEffect)(function () {
        componentCallback = onReceiveParams;
        return function () {
            componentCallback = null;
        };
    }, [onReceiveParams]);
    return ((0, jsx_runtime_1.jsxs)(Dialog_1.default, tslib_1.__assign({ visible: opened, onClose: params === null || params === void 0 ? void 0 : params.onCancel }, { children: [(0, jsx_runtime_1.jsx)(Dialog_1.default.Header, { children: (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : ((params === null || params === void 0 ? void 0 : params.confirmation) ? 'Confirmação' : 'Atenção') }), (0, jsx_runtime_1.jsx)(Dialog_1.default.Content, { children: params === null || params === void 0 ? void 0 : params.message }), (0, jsx_runtime_1.jsxs)(Dialog_1.default.Footer, { children: [(params === null || params === void 0 ? void 0 : params.confirmation) && ((0, jsx_runtime_1.jsx)(Button_1.default, tslib_1.__assign({ onClick: params === null || params === void 0 ? void 0 : params.onCancel, variant: 'text', loading: cancelLoading, disabled: confirmLoading }, { children: "Cancelar" }))), (0, jsx_runtime_1.jsx)(Button_1.default, tslib_1.__assign({ onClick: params === null || params === void 0 ? void 0 : params.onConfirm, loading: confirmLoading, disabled: cancelLoading }, { children: "OK" }))] })] })));
});
function callComponent(params) {
    var _this = this;
    //prevent an alert to override another
    return (lastPromise = lastPromise.finally(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(function () { return resolve(); }, 300); })];
                case 1:
                    _a.sent();
                    if (!componentCallback)
                        throw new Error('Please, initialize an DialogGlobal before');
                    return [2 /*return*/, componentCallback(params)];
            }
        });
    }); }));
}
/**
 * @deprecated Use Modal from Antd
 * https://ant.design/components/modal/
 */
function showAlert(params) {
    return callComponent(typeof params === 'string' ? { message: params } : params);
}
exports.showAlert = showAlert;
/**
 * @deprecated Use Modal from Antd
 * https://ant.design/components/modal/
 */
function showConfirm(params) {
    return callComponent(tslib_1.__assign(tslib_1.__assign({}, (typeof params === 'string' ? { message: params } : params)), { confirmation: true }));
}
exports.showConfirm = showConfirm;
/**
 * @deprecated Use Modal from Antd
 * https://ant.design/components/modal/
 */
exports.default = DialogGlobal;
